export default __webpack_public_path__ + "static/media/grunt.0eff8e9e.svg";